import { css, Interpolation, Theme } from "@emotion/react"
import typography from "themes/typography"

export const searchContainer: Interpolation<Theme> = (theme: Theme) => css`
    padding: 0 0 0 14px;
    width: 275px;
    border: 1px solid ${theme.palette.Midnight[10]};
    border-radius: 100px;
`

export const searchInput: Interpolation<Theme> = (theme: Theme) => css`
    ${typography.bodySmallSemiBold}
    font-weight: 500;
    color: ${theme.palette.Dusk[50]};
`

export const searchForm = css`
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
`

export const searchSubmit: Interpolation<Theme> = (theme: Theme) => css`
    &.MuiButton-root {
        padding: 0px 30px;
        height: 42px;
        background: ${theme.palette.Midnight[10]};
        ${typography.headingXSmallCaps}

        &:hover {
            background: ${theme.palette.Midnight[20]};
        }
    }
`
